document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.popup-card__block').forEach((block) => {
    block.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;

      const modalId = block.getAttribute('data-modal-id');
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.remove('popup-card__modal--hidden');
        document.body.classList.add('no-scroll');
      }
    });
  });

  document.querySelectorAll('[data-close-modal]').forEach((btn) => {
    btn.addEventListener('click', function () {
      const modal = btn.closest('.popup-card__modal');
      modal.classList.add('popup-card__modal--hidden');
      document.body.classList.remove('no-scroll');
    });
  });

  document.querySelectorAll('.popup-card__modal').forEach((modal) => {
    modal.addEventListener('click', function (e) {
      const content = modal.querySelector('.popup-card__modal-content');
      if (!content.contains(e.target)) {
        modal.classList.add('popup-card__modal--hidden');
        document.body.classList.remove('no-scroll');
      }
    });
  });
});
